import type { FaireProductEntity } from "../../entity_types/product";

export const p_xrbyfwvcjx: FaireProductEntity = {
  token: "p_xrbyfwvcjx",
  type: "product",
  name: "E. Frannie Pack (Bubblegum)",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/4bb851c1450fd4a25546fb90a2d24b4e9709a62efa248aedd94efcafd2a36cc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dff7f7d882850788771d288fe43324e5b8e29bb254afe7930cd33b8b79e049ee.jpeg",
    "https://cdn.faire.com/fastly/bfaa2b424a2b5ee6cd63665a69842b19de191a4e9af03d729beeee9373311acd.png",
    "https://cdn.faire.com/fastly/6241ca70e4626830ec250512eadcf04b3afdc0934fff2af5bbe3e3bb8cd7615e.jpeg",
    "https://cdn.faire.com/fastly/90619d575d1f1a13a19d1cb3c2da25593612f8d7b3446fad4067f773cc668f60.png"
  ],
  priceDollars: 9,
  description: "Meet your Little Notes® sidekick! The E. Frannie Pack is ready for bags, cars, coat pockets...leave a note under someone's windshield. Under someone's doormat. A smile for the bank teller at the other end of that frightening, traveling tube. Anywhere joy might be needed. It snuggly fits about 25 Little Notes®. The E.Frannie Pack is cute, practical, and the perfect gift for anyone who loves sprinkling more joy into the world.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:19.198Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
